export default __webpack_public_path__ + "images/amazon_log_arrow.png";